import React from 'react';
import { Text, Title1, Link, LargeTitle, Subtitle2 } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '#root/routes/constants';

const ServerDown: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '80vh',
            textAlign: 'center'
        }}>
            <LargeTitle style={{ color: '#0078D4' }}>Oops! Something Went Wrong</LargeTitle>
            <Subtitle2 style={{ marginTop: '20px', marginBottom: '5px' }}>
                It looks like our server is temporarily unavailable.
            </Subtitle2>
            <Subtitle2 style={{ marginBottom: '30px' }}>
                But don't worry, we're working hard to get things back up and running!
            </Subtitle2>
            
            <Title1>What Can You Do?</Title1>
            <Text size={400} style={{ display: 'block', marginTop: '10px' }}>
                Go back to our homepage – <Link onClick={() => navigate(ROUTES.ROOT)}>Click here</Link> to return home.
            </Text>
            <Text size={400} style={{ display: 'block', marginTop: '10px' }}>
                Contact us – If you need assistance, feel free to <Link href="mailto:techsupport@emcplatforms.com">reach out</Link>.
            </Text>
        </div>
    );
};

export default ServerDown;
